const initialState = {
    searchAccountLedger: [],
    isFetchingAccountLedger: false,
};


const AccountLegderReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_SEARCH_LEDGER":
            return { ...state, isFetchingAccountLedger: true };
        case "SUCCESS_SEARCH_LEDGER":
            return { ...state, searchAccountLedger: action.payload, isFetchingAccountLedger: false };
        case "ERROR_SEARCH_LEDGER":
            return { ...state, isFetchingAccountLedger: false };


        default:
            return state;
    }
};

export default AccountLegderReducer;